import { removeFtm } from "../../../storage/ftm";
import { removeStep } from "../../../storage/step";
import { theme } from "../../../theme";

const CreateNewAccountButton = () => {
    return (
        <button
            className={`btn btn-sm btn-${theme.main} w-100`}
            onClick={() => {
                removeFtm();
                removeStep();
                window.location.href = "/";
            }}
        >
            <i className="material-icons text-lg me-2" >how_to_reg</i> Reset Form
        </button>
    );
};

export default CreateNewAccountButton;